import React, {
  useLayoutEffect,
  useCallback,
  useEffect,
  useRef,
  useState,
} from "react";
import { useDispatch, useSelector } from "react-redux";
import moment from "moment";
import axios from "axios";
import { isEmpty } from "lodash";
import toast from "react-hot-toast";

// actions

// css
import "./style.css";

import * as URL from "../../../helpers/url_helper";
import { post } from "../../../helpers/api_helper";

import * as Angle_Helpers from "../../../helpers/wheelAngle";
import WheelSvg from "../../../helpers/wheelSvg";

// actions
import actions from "../../../store/actions";
import { hideLoader, showLoader } from "../../../store/loader";

const svgHeightWidth = 1000000;
const initialZoom = 0.5;
const minZoom = 0.1;
const maxZoom = 3;

const masterPlanet = "sun";

const GannWheel = () => {
  const dispatch = useDispatch();
  const doubleClick = useRef(null);
  const containerRef = useRef(null);
  const svgRef = useRef(null);
  const wheelSvgRef = useRef(null);

  const gannWheel = useSelector((state) => state.gannWheel);

  const [astroD, setastroD] = useState({});
  const [zoom, setZoom] = useState(initialZoom);
  const [deltaX, setdeltaX] = useState(0);
  const [deltaY, setdeltaY] = useState(0);
  const [planetAnglesData, setPlanetAnglesData] = useState(null);

  useLayoutEffect(() => {
    if (!svgRef.current) return;

    // Calculate dimensions based on desired size
    const width = svgRef.current.clientWidth;
    const height = svgRef.current.clientHeight;

    const centerX = width / 2;
    const centerY = height / 2;

    wheelSvgRef.current = new WheelSvg(centerX, centerY);
  }, []);

  useEffect(() => {
    async function getGannWheelData() {
      try {
        dispatch(showLoader());
        await dispatch(actions.getGannWheel());
        dispatch(hideLoader());
      } catch(err) {
        console.log("Error fetching Gann Wheel data", err);
        dispatch(hideLoader());
      }
    }

    getGannWheelData();
  }, []);

  useEffect(() => {
    if (gannWheel) {
      const timeout = setTimeout(() => {
        dispatch(actions.updateGannWheel(gannWheel));
      }, 2000);

      return () => {
        clearTimeout(timeout);
      };
    }
  }, [gannWheel]);

  useEffect(() => {
    if (!wheelSvgRef.current || !gannWheel || !astroD) return;

    let _svgcontent = [];

    const svg = svgRef.current;
    const radius = 120;
    const space = 30;
    const rings = Number(gannWheel.gridSettings.rings);
    const increment = Number(gannWheel.gridSettings.increment);
    const colorCode = "#7d96b31a";
    const startAt = moment(gannWheel.planetSettings.ephemerisDate ?? null);

    // Clear the svg content before drawing
    svg.innerHTML = "";

    function createTimeLabel(day, prevRadius, radius, planets, price, planetAngles) {
      const hours = 24;
      const currentDay = day - 1;

      let currentHour = Number(gannWheel.gridSettings.startPrice);

      const group = document.createElementNS("http://www.w3.org/2000/svg", "g");
      group.setAttribute("class", "price-circle-group");

      for (let angle = 7.5; angle < 360; angle += 15) {
        const priceGroup = document.createElementNS(
          "http://www.w3.org/2000/svg",
          "g"
        );
        priceGroup.setAttribute("class", "price-group");

        // reverse angle
        const _angle = 360 - angle;
        const textContent = Number(currentDay * hours + currentHour);

        const curveAngle = 360 - (angle + 7.5);

        const path = wheelSvgRef.current.curvePath(
          curveAngle,
          15,
          prevRadius,
          radius
        );
        path.setAttribute("stroke", "#00000026");

        if (gannWheel.gridSettings.selectedPrice === textContent) {
          path.setAttribute("class", "highlight");
        }

        path.onclick = (evt) => {
          if (doubleClick.current) {
            clearInterval(doubleClick.current);
          }

          if (evt.detail === 2) {
            if (doubleClick.current) {
              clearInterval(doubleClick.current);
              doubleClick.current = null;
            }

            dispatch(
              actions.updateByName({
                category: "gridSettings",
                name: "selectedPrice",
                value: textContent,
              })
            );
          } else {
            doubleClick.current = setTimeout(() => {
              dispatch(
                actions.updateByName({
                  category: "overlaySettings",
                  name: "barAngle",
                  value: _angle,
                })
              );
              dispatch(
                actions.updateByName({
                  category: "gridSettings",
                  name: "selectedAngle",
                  value: _angle,
                })
              );
            }, 200);
          }
        };
        path.setAttribute("fill", "none");

        priceGroup.appendChild(path);

        if (textContent == price) {
          const href = require(`../../../Assets/images/dollar-sign.png`);
          const image = wheelSvgRef.current.createPriceImages(
            radius,
            _angle,
            href,
            32
          );
          priceGroup.appendChild(image);
        } else if (planets[textContent]) {
          planets[textContent].forEach((planetData) => {
            const { href, planetName } = planetData;
            const image = wheelSvgRef.current.createPriceImages(
              radius,
              _angle,
              href,
              32
            );
            priceGroup.appendChild(image);

            planetAngles[planetName] = _angle;
          });
        } else {
          const text = wheelSvgRef.current.createTimeLabelText(
            radius,
            _angle,
            textContent
          );
          priceGroup.appendChild(text);
        }

        currentHour += increment;

        group.appendChild(priceGroup);
      }

      return group;
    }

    function createCircleAndPrice(radius, days, planets, price) {
      let newRadius = radius;

      const planetAngles = {};
      const prices = [];
      for (let day = 1; day <= days; day++) {
        const roundRadius = space * day + radius;

        const priceGroup = createTimeLabel(
          day,
          newRadius,
          roundRadius,
          planets,
          price,
          planetAngles
        );
        prices.push(priceGroup);
        newRadius = roundRadius;
      }

      const group = document.createElementNS("http://www.w3.org/2000/svg", "g");
      group.setAttribute("class", "prices");

      const circle = wheelSvgRef.current.createCircle(
        newRadius,
        false,
        false,
        "price-circle"
      );
      group.appendChild(circle);

      const horizontalLine = wheelSvgRef.current.createLine(
        newRadius,
        newRadius,
        0,
        colorCode
      );
      const verticalLine = wheelSvgRef.current.createLine(
        newRadius,
        newRadius,
        90,
        colorCode
      );

      group.appendChild(verticalLine);
      group.appendChild(horizontalLine);
      prices.reverse();
      prices.forEach((priceGroup) => group.appendChild(priceGroup));

      _svgcontent.push(group);

      return {
        newRadius,
        planetAngles
      };
    }

    const circle = wheelSvgRef.current.createCircle(
      radius,
      false,
      true,
      "empty-circle"
    );
    svg.appendChild(circle);

    let prevRadius = radius;
    const planetsRequired = gannWheel.wheelSettings.wheels.find(
      (wheel) => wheel.display === "planets" && wheel.enabled
    );

    let planetDegree = {};
    if (!!planetsRequired) {
      astroD.planets
        ?.filter((planet) => gannWheel.planets[planet.name.toLowerCase()])
        ?.forEach((planet) => {
          const planetName = planet.name.toLowerCase();
          const href = require(`../../../Assets/images/planet_${planetName}_${
            planet.is_retro === true ? "red" : "blue"
          }.png`);

          const full_degree = Math.round(planet.full_degree);
          if (planetDegree[full_degree]) {
            planetDegree[full_degree].push({
              href,
              planetName
            });
          } else {
            planetDegree[full_degree] = [{
              href,
              planetName
            }];
          }
        });
    }
    let { newRadius, planetAngles } = createCircleAndPrice(
      radius,
      rings,
      planetDegree,
      gannWheel.planetSettings.price
    );

    if(isEmpty(planetAnglesData) && !isEmpty(planetAngles)) {
      setPlanetAnglesData(planetAngles);
    }

    gannWheel.wheelSettings.wheels
      .filter((wheel) => wheel.enabled)
      .forEach((wheel) => {
        let circle;
        const wheelGroup = document.createElementNS(
          "http://www.w3.org/2000/svg",
          "g"
        );

        wheelGroup.setAttribute("class", `${wheel.display}-wheel`);

        switch (wheel.display) {
          case "degrees":
            prevRadius = newRadius;
            newRadius += space * 2;
            circle = wheelSvgRef.current.createCircle(newRadius);

            const degreeMarkings = wheelSvgRef.current.createDegreeMarkings(
              newRadius,
              wheel.direction
            );
            wheelGroup.appendChild(degreeMarkings);

            const degreeText = wheelSvgRef.current.createDegreeText(
              newRadius - space,
              wheel.direction
            );
            wheelGroup.appendChild(degreeText);

            break;

          case "year":
            prevRadius = newRadius;
            newRadius += space * 1.8;
            circle = wheelSvgRef.current.createCircle(newRadius);

            const dateMarkings = wheelSvgRef.current.createDateMarking(
              newRadius,
              wheel.direction,
              startAt
            );
            wheelGroup.appendChild(dateMarkings);

            break;

          case "day":
            prevRadius = newRadius;
            newRadius += space;

            const timeMarkings = wheelSvgRef.current.createTimeMarking(
              newRadius,
              wheel.direction
            );
            wheelGroup.appendChild(timeMarkings);

            break;

          case "planets":
            prevRadius = newRadius;
            newRadius += space * 1.5;
            circle = wheelSvgRef.current.createCircle(newRadius, colorCode);

            const astroMarking = wheelSvgRef.current.createAstroMarking(
              prevRadius,
              newRadius,
              colorCode
            );
            wheelGroup.appendChild(astroMarking);

            const planetsGroup = document.createElementNS(
              "http://www.w3.org/2000/svg",
              "g"
            );
            planetsGroup.setAttribute("class", "planets");
            // print planets
            astroD.planets
              ?.filter((planet) => gannWheel.planets[planet.name.toLowerCase()])
              ?.forEach((planet) => {
                const href = require(`../../../Assets/images/planet_${planet.name.toLowerCase()}_black.png`);

                const image = wheelSvgRef.current.createImages(
                  newRadius,
                  planet.full_degree,
                  href
                );
                planetsGroup.appendChild(image);
              });
            wheelGroup.appendChild(planetsGroup);

            // print houses
            const housesGroup = document.createElementNS(
              "http://www.w3.org/2000/svg",
              "g"
            );
            housesGroup.setAttribute("class", "houses");
            astroD.houses?.forEach((house) => {
              const href = require(`../../../Assets/images/house_${house.sign.toLowerCase()}_grey.png`);

              const image = wheelSvgRef.current.createImages(
                newRadius,
                house.degree,
                href
              );
              housesGroup.appendChild(image);
            });
            wheelGroup.appendChild(housesGroup);
            break;
        }

        circle && wheelGroup.appendChild(circle);
        _svgcontent.push(wheelGroup);
      });

    const overlaysGroup = document.createElementNS(
      "http://www.w3.org/2000/svg",
      "g"
    );
    overlaysGroup.setAttribute("id", "overlays"); // Create overlays group
    gannWheel.overlaySettings.overlays
      .filter((overlay) => overlay.enabled && overlay.value)
      .forEach((overlay) => {
        let masterPlanetAngle = planetAngles[masterPlanet];
        let _selectionAngle = 0;
        if(masterPlanetAngle) {
          _selectionAngle = masterPlanetAngle - 7.5;
        } else {
          _selectionAngle =
            overlay.startFrom === "fixed"
              ? overlay.value
              : (gannWheel.gridSettings.selectedAngle || 0) - 7.5;
        }
        const angles = Angle_Helpers.getDegreesWithGap(
          Number(_selectionAngle),
          overlay.repeat ? overlay.value : 0
        );

        const group = document.createElementNS(
          "http://www.w3.org/2000/svg",
          "g"
        );
        group.setAttribute(
          "class",
          `${overlay.startFrom} repeat-${overlay.repeat ? 1 : 0}`
        );

        angles.forEach((angle) => {
          const overlayGroup = wheelSvgRef.current.createOverlay(
            newRadius,
            angle,
            overlay
          );
          group.appendChild(overlayGroup);
        });

        overlaysGroup.appendChild(group);
        _svgcontent.push(overlaysGroup);
      });

    const mainGroup = document.createElementNS(
      "http://www.w3.org/2000/svg",
      "g"
    );
    mainGroup.setAttribute("id", "main-group");
    mainGroup.setAttribute("class", "main-group");

    _svgcontent.reverse();
    _svgcontent.forEach((ele) => mainGroup.appendChild(ele));

    // draw overlay
    const overlayBar = wheelSvgRef.current.createOverlayBar(
      deltaX,
      deltaY,
      newRadius,
      space,
      gannWheel.overlaySettings.barWidth,
      gannWheel.overlaySettings.barAngle,
      (angle) => {
        // console.log(angle, "<===angle");

        dispatch(
          actions.updateByName({
            category: "overlaySettings",
            name: "barAngle",
            value: angle,
          })
        );
      }
    );
    mainGroup.appendChild(overlayBar);

    // draw directions
    prevRadius = newRadius;
    newRadius += space;
    const directions = wheelSvgRef.current.createDirections(newRadius);

    svg.appendChild(directions);
    svg.appendChild(mainGroup);
  }, [JSON.stringify(gannWheel), JSON.stringify(astroD)]);

  useEffect(() => {
    if (!gannWheel) return;
    async function planetPlacements() {
      try {
        let response = await post(URL.GET_ASTROLOGY, {
          ephemerisDate: gannWheel.planetSettings.ephemerisDate,
          gmtOffset: "00:00"
        });

        if(response?.status === "failure") {
          toast.error("Failed to load data for Wheel of 24");
          return;
        }

        setastroD(response.data);
      } catch (err) {
        console.log("API fail", err);
      }
    }

    const planetTimeout = setTimeout(planetPlacements, 1000);

    return () => {
      clearTimeout(planetTimeout);
    };
  }, [gannWheel?.planetSettings?.ephemerisDate]);

  useEffect(() => {
    if (!svgRef.current) return;

    if (deltaX === 0 && deltaY === 0) {
      const cHeightY = containerRef.current.clientHeight / 2;
      const cWidthX = containerRef.current.clientWidth / 2;
      const svgHeightWidth_half = svgHeightWidth / 2;

      const _deltaY = svgHeightWidth_half - cHeightY;
      const _deltaX = svgHeightWidth_half - cWidthX;

      setdeltaY(-_deltaY);
      setdeltaX(-_deltaX);
    } else {
      svgRef.current.setAttribute(
        "transform",
        `translate(${deltaX}, ${deltaY}) scale(${zoom})`
      );
      svgRef.current.setAttribute("transform-origin", "50% 50%");
    }
  }, [deltaX, deltaY, zoom]);

  const handleZoom = (delta) => {
    setZoom((prevZoom) => {
      const newZoom = prevZoom - delta;
      return Math.min(Math.max(newZoom, minZoom), maxZoom); // Enforce zoom limits
    });
  };

  const handleMouseWheel = useCallback(
    (event) => {
      const delta = event.deltaY / 2000; // Adjust sensitivity as needed
      handleZoom(delta);
    },
    [zoom]
  );

  useEffect(() => {
    if (!containerRef.current) return;
    containerRef.current.addEventListener("wheel", handleMouseWheel);
    return () =>
      containerRef.current &&
        containerRef.current.removeEventListener("wheel", handleMouseWheel);
  }, [handleMouseWheel]); // Only add event listener once

  const handleMouseDown = (event) => {
    // console.log("sfsdfsdf", event.target.closest("#overlay-bar"));
    if (!!event.target.closest("#overlay-bar")) return;
    // if (!event.target.closest("svg")) return; // Handle clicks outside the SVG
    const clientX = event.clientX - deltaX;
    const clientY = event.clientY - deltaY;

    let _deltaX = 0;
    let _deltaY = 0;

    const handleMouseMove = (moveEvent) => {
      if (!!event.target.closest("#overlay-bar")) return;
      // if (!event.target.closest("svg")) return; // Handle dragging outside the SVG

      _deltaX = moveEvent.clientX - clientX;
      _deltaY = moveEvent.clientY - clientY;

      svgRef.current.setAttribute(
        "transform",
        `translate(${_deltaX}, ${_deltaY}) scale(${zoom})`
      );
    };

    const handleMouseUp = () => {
      setdeltaX(_deltaX);
      setdeltaY(_deltaY);

      window.removeEventListener("mousemove", handleMouseMove);
      window.removeEventListener("mouseup", handleMouseUp);
    };

    window.addEventListener("mousemove", handleMouseMove);
    window.addEventListener("mouseup", handleMouseUp);
  };

  return (
    <section
      style={{ height: "calc(100vh - 85px)", width: "calc(100vw - 282px)" }}
    >
      <div
        ref={containerRef}
        style={{
          height: "100%",
          width: "100%",
          webkitUserSelect: "none",
          mozUserSelect: "none",
          msUserSelect: "none",
          userSelect: "none",
        }}
        onMouseDown={handleMouseDown}
      >
        <div
          className="content-wrapper"
          style={{
            width: "100%",
            height: "100%",
          }}
        >
          <svg ref={svgRef} height={svgHeightWidth} width={svgHeightWidth} />
          {/* <svg
            ref={svgRef}
            id="main-svg"
            style={{
              height: "calc(100vh - 85px)",
              width: "calc(100vw - 282px)",
            }}
          /> */}
        </div>
      </div>
    </section>
  );
};

export default GannWheel;
